<template>
    <div>
        <v-menu 
            v-if="!dialog"
            v-model="menuDateSelect" 
            :close-on-content-click="false" 
            offset-y  offset-overflow
            :nudge-width="500" rounded="xl"
            >
            <template v-slot:activator="{ on, attrs }"> 
                <v-card   v-on="on" class="transparent"
                    width="100%" min-width="150"
                     min-height="20"  flat >
                    <v-layout fill-height align-center class="ma-0  ">
                        <v-icon size="" class="mr-3" :color="icon_color">mdi-network-pos</v-icon>
                        <v-spacer></v-spacer>
                        <div :class="color?color+'--text':'grey--text '" class="pb-1">
                            
                            <!-- <div 
                                class="font-weight-bold not-f3  text--darken-1">
                                {{moment(fromDate).format('Do, MMM YYYY')}} -
                                {{moment(toDate).format('Do, MMM YYYY')}}
                            </div>  -->
                            <span :class="title_color?title_color+'--text':''" class="font-weight-bold not-f3  text--darken-1">{{MBS.actions.SIZE(DayShiftsFiltered)}} DayShift(s)</span>
                            <div   class="font-weight-bold not-f3 ">
                                <span>{{moment(fromDate).format('yyyy/MM/DD')}} - {{moment(toDate).format('yyyy/MM/DD')}}</span>
                                (<span v-if="toNumber(difference)==0">Today</span>
                                <span v-else-if="difference==1">Yesterday</span>
                                <span v-else>Last {{difference}} Days</span>)
                            </div> 
                        </div>
                       <v-icon class="ml-2" :color="icon_color">arrow_drop_down</v-icon>
                    </v-layout>
                    <!-- <div class="mt- mx-"><hr></div>  -->
                </v-card> 
            </template>  
            <v-card>
                <v-toolbar tile flat color="secondary">
                    <div :class="'white--text pl-3'">
                        <div class="not-f2 ">
                            <div v-if="DIFF(filter_date?.from_date,filter_date?.to_date)==0">Today</div>
                            <div v-else-if="DIFF(filter_date?.from_date,filter_date?.to_date)==1">Yesterday</div>
                            <div v-else>Last {{DIFF(filter_date?.from_date,filter_date?.to_date)}} Days</div>
                        </div> 
                        <span class="font-weight-bol">{{MBS.actions.SIZE(filter_date?.dayshifts)}} DayShift(s)</span>
                    </div>
                    <v-spacer></v-spacer>
                    <!-- <v-btn color="" dark text @click="DEFAULT()">Default</v-btn> -->
                    <v-btn color=""   dark text @click="menuDateSelect =false "><v-icon>close</v-icon></v-btn>
                </v-toolbar>
                <mbs-dayshift-selector-body
                    v-model="filter_date"
                    :color="color"
                    :icon_color="icon_color"
                    :title_color="title_color"
                    :max_from_date="max_from_date"
                    :min_from_date="min_from_date"
                    :max_to_date="max_to_date"
                    :min_to_date="min_to_date"
                    :default_days="default_days"
                    :optional_dates="optional_dates"
                    :on_start="on_start" 
                    :filter_dayshifts="filter_dayshifts" 
                    :filter_dayshifts_fixed="filter_dayshifts_fixed" 
                />
                <v-divider></v-divider>
                <v-card-actions class="b1">
                    <v-spacer></v-spacer>
                    <v-btn text @click="menuDateSelect = false">Cancel</v-btn>
                    <v-btn text color="" @click="APPLY_DATE()">Apply</v-btn>
                </v-card-actions> 
                
            </v-card> 
        </v-menu>
        
        <v-dialog v-else-if="dialog"
            v-model="dialog_audit_aggregate_sales"
            scrollable   
            :persistent="false" 
            :overlay="false"
            max-width="900px"
            transition="dialog-transition" >
            <v-card rounded="lg" v-if="dialog_audit_aggregate_sales">
                <v-toolbar dark tile flat color="primary">
                    <span class="mr-2">
                        <v-icon v-if="title_icon">{{ title_icon }}</v-icon>
                        <v-icon v-else>mdi-network-pos</v-icon>
                    </span>
                    <v-toolbar-title text="">
                        <span v-if="title_text">{{ title_text }}</span>
                        <span v-else>DayShift Selector</span> 
                    </v-toolbar-title>
                    <v-spacer></v-spacer> 
                    <v-btn  outlined>
                        <div :class="'white--text pl-3 font'">
                            <div class="not-f2 ">
                                <div v-if="DIFF(filter_date?.from_date,filter_date?.to_date)==0">Today</div>
                                <div v-else-if="DIFF(filter_date?.from_date,filter_date?.to_date)==1">Yesterday</div>
                                <div v-else>Last {{DIFF(filter_date?.from_date,filter_date?.to_date)}} Days</div>
                            </div> 
                            <span class="font-weight-bol">{{MBS.actions.SIZE(filter_date?.dayshifts)}} DayShift(s)</span>
                        </div> 
                    </v-btn>
                    <v-btn color=""   dark text @click="dialog_audit_aggregate_sales =false "><v-icon>close</v-icon></v-btn>
                </v-toolbar>
                <v-card class="mbs-scroll-y" :height="body_height"  flat tile>
                    <mbs-dayshift-selector-body
                        v-model="filter_date"
                        :color="color"
                        :body_height="body_height"
                        :icon_color="icon_color"
                        :title_color="title_color"
                        :max_from_date="max_from_date"
                        :min_from_date="min_from_date"
                        :max_to_date="max_to_date"
                        :min_to_date="min_to_date"
                        :default_days="default_days"
                        :optional_dates="optional_dates"
                        :on_start="on_start" 
                        :filter_dayshifts="filter_dayshifts" 
                        :filter_dayshifts_fixed="filter_dayshifts_fixed" 
                    /> 
                </v-card>
                <v-divider></v-divider> 
                <v-card-actions class="b1">
                    <v-spacer></v-spacer>
                    <v-btn text @click="dialog_audit_aggregate_sales = false">Cancel</v-btn>
                    <v-btn text color="" @click="APPLY_DATE()">Apply</v-btn>
                </v-card-actions>    
            </v-card> 
        </v-dialog> 
    </div>
</template> 
<script>
let NAME = 'DAY-SHIFT-SELECTOR'
import moment from 'moment'
import {mapState} from "vuex"
import DATA from '../../plugins/DATA';
import { toNumber } from '../../plugins/formatNumber';
export default { 
    props:['dialog','title_text','title_icon','color','icon_color','title_color',
        'max_from_date','min_from_date','max_to_date','min_to_date',
        'default_days','optional_dates','on_start','filter_dayshifts','filter_dayshifts_fixed'], 
    data(){
        return{ 
            menuDateSelect:false, 
            dialog_audit_aggregate_sales:false, 
            select:{
                signOption:'',
                accountType:'',
                businessType:'',
                country:''
            },
            psw1: true, 
            input:{ 
            },
            input_outlets:null,
            item_multiple_select:false,
            inputPhone:'',
            inputLoading:false,
            date:"17/01/2020 - 17/01/2020",
            inputFromDate:moment().subtract(5,'day').format('yyyy-MM-DD'),
            inputToDate:moment().format('yyyy-MM-DD'), 
            menuFromDate:false,
            menuToDate:false, 
            fromDate: null,
            toDate: null,
            difference: null, 
            filter_date: null, 
            selected: [],
            headers: [ 
                { text: 'Open', value: 'local_created_at_', cellClass:'with-divider-lr' },
                { text: 'Close', value: 'time_closed', cellClass:'with-divider'  },
                { text: 'Operational', value: 'operating_date_' , cellClass:'with-divider' },
                { text: 'Outlet', value: 'outlet_name' , cellClass:'with-divider' },
                { text: 'User', value: 'user_name' , cellClass:'with-divider-' },
            ],
        }  
    },
    created(){
        this.MBS.events.$on('DIALOG_YES', this.DIALOG_YES);  
        this.MBS.events.$on('ON_DAYSHIFT_SELECTOR', this.ON_DAYSHIFT_SELECTOR);  
    },
    mounted(){
        this.input={}
        this.inputLoading=false
        if (this.default_days) {
            let item = {from:this.default_days,from_type:"days"} 
            this.CHANGE_DATE(item)
        } 
        this.fromDate = this.inputFromDate
        this.toDate = this.inputToDate 
        if (this.on_start) {
            this.APPLY_DATE() 
        }
    },
    computed:{
        vs(){
            return this.$vuetify.breakpoint
        }, 
        vsh(){
            return this.vs.height
        }, 
        body_height(){
            return this.vsh-200
        }, 
        moment(){ 
            return moment
        }, 
        lastDays(){ 
            return this.MBS.date.moment
        }, 
        ...mapState({
            loading:state=>state.load.loading,
            processes:state=>state.load.processes,
            responses:state=>state.load.responses,
        }),
        ...mapState({
            us: state=> state.users[(DATA.ITEMS.USERS.value).toUpperCase()],
            ud: state=> state.users[(DATA.ITEMS.USER_DETAILS.values).toUpperCase()],
        }),
        ...mapState({ 
            Outlets: state=> state.items[(DATA.ITEMS.STOCK_OUTLETS.values).toUpperCase()],
            JoinedOutlets: state=> state.join[(DATA.ITEMS.STOCK_OUTLETS.values).toUpperCase()], 
            Departments: state=> state.items[(DATA.ITEMS.ITEM_DEPARTMENTS.values).toUpperCase()],
            JoinedDepartments: state=> state.join[(DATA.ITEMS.ITEM_DEPARTMENTS.values).toUpperCase()], 
            DayShifts: state=> state.items[(DATA.ITEMS.DAYS_SHIFTS.values).toUpperCase()],
            JoinedDayShifts: state=> state.join[(DATA.ITEMS.DAYS_SHIFTS.values).toUpperCase()], 
            Cashups: state=> state.items[(DATA.ITEMS.CASHUPS.values).toUpperCase()],
            JoinedCashups: state=> state.join[(DATA.ITEMS.CASHUPS.values).toUpperCase()],
        }), 
        OutletsData(){ 
            let Outlets = this.Outlets
            let JoinedOutlets = this.JoinedOutlets
            let items = JoinedOutlets?JoinedOutlets:Outlets 
            return items
        }, 
        OutletsFilter(){ 
            let outlets = this.OutletsData 
            let items = [
                // {code:0,name:"All Outlets"}
            ]
            if (outlets) {
                items.push(...outlets)
            }
            return items
        }, 
        DayShiftsData(){ 
            let DayShifts = this.DayShifts
            let JoinedDayShifts = this.JoinedDayShifts
            let items = JoinedDayShifts?JoinedDayShifts:DayShifts  
            if(!items){return null}
            let list = [...items]
            list.sort(this.MBS.actions.dynamicSort("local_created_at",false))   
            return list 
        }, 
        DayShiftsFiltered(){
            const input_outlets = this.input_outlets
            const days = this.DayShiftsData
            const from_date = this.inputFromDate
            const to_date = this.inputToDate
            const difference = this.difference
            if(!days){return null}
            // if(!this.MBS.actions.SIZE(input_outlets)){return days}
            // if(input_outlets[0] == 0){return days}
            let filtered = days.filter(day=>{
                const index = input_outlets?.indexOf(day.outlet_code)
                const is_outlet =  this.MBS.actions.SIZE(input_outlets)?index != -1:true
                const open_date = day.local_created_at
                const close_date = day.local_close_at
                const open_moment = moment(moment(open_date).format("yyyy-MM-D"))
                const close_moment = moment(moment(close_date).format("yyyy-MM-D"))
                const is_open = open_moment.isBetween(from_date,to_date,'','[]')
                const is_close = close_moment.isBetween(from_date,to_date,'','[]')
                return is_outlet && (is_open || is_close)
            })  
            return filtered
        },
        DayShiftsKeys(){
            const dayshifts = this.DayShiftsFiltered
            if(!dayshifts){return null}
            let codes = []
            dayshifts.forEach(day => {
                codes.push(day.key) 
            });
            return codes
        },
        SelectedDayShiftsKeys(){
            const dayshifts = this.selected
            if(!dayshifts){return null}
            let codes = []
            dayshifts.forEach(day => {
                codes.push(day.key) 
            });
            return codes
        },
        OptionalDays(){ 
            let days = this.optional_days
            if (days) {
               return days 
            }
            return  [
                {name:"Today",days:0,from:"0",from_type:"days"},
                {name:"Last 7 Days",days:7,from:"7",from_type:"days"},
                {name:"Last 30 Days",days:30,from:"30",from_type:"days"},
                {name:"Last 3 Months",days:90,from:"90",from_type:"days"},
                {name:"Last 6 Months",days:180,from:"180",from_type:"days"},
                {name:"Last 12 Months",days:365,from:"12",from_type:"months"},
            ]
        },  
         
    },
    methods:{
        DEFAULT(default_days){
            try { 
                if (!default_days) {
                    default_days = this.default_days
                }
                if (default_days) {
                    let item = {from:default_days,from_type:"days"} 
                    this.CHANGE_DATE(item)
                }    
                this.APPLY_DATE() 
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'CHANGE_DATE',
                    page:NAME, 
                }) 
            }
            
        },
        APPLY_DATE(){
            try { 
                // this.fromDate = this.inputFromDate
                // this.toDate = this.inputToDate 
                // this.difference = this.DIFF(this.fromDate,this.toDate)
                // this.menuDateSelect = false  
                // this.dialog_audit_aggregate_sales = false  
                // let send_data = {
                //     from_date:this.fromDate,
                //     to_date:this.toDate,
                //     difference:this.difference,
                //     outlet_code:this.OutletsFilter,
                //     dayshifts:this.DayShiftsFiltered,
                //     dayshifts_keys:this.DayShiftsKeys,
                //     selected_dayshifts:this.selected,
                //     selected_dayshifts_keys:this.SelectedDayShiftsKeys,
                // }

                this.menuDateSelect = false  
                this.dialog_audit_aggregate_sales = false  
                this.MBS.events.$emit("GET_DAYSHIFT_SELECTOR_DATA")
                let send_data =  this.filter_date
                console.log(send_data,'send_data.....'); 
                
                this.$emit('input', send_data )
                this.$emit('apply', send_data )

            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'CHANGE_DATE',
                    page:NAME, 
                }) 
            }
            
        },
        CHANGE_DATE(item){
            try { 
                let from = item?item.from:null
                let from_type = item?item.from_type:null
                let to = item?item.to:null
                let to_type = item?item.to_type:null 
                if (from) {
                    this.inputFromDate = moment().subtract(from,from_type).format('yyyy-MM-DD') 
                }else {
                    this.inputFromDate = moment().format('yyyy-MM-DD') 
                }
                if (to) {
                    this.inputToDate = moment().subtract(to,to_type).format('yyyy-MM-DD') 
                }else {
                    this.inputToDate = moment().format('yyyy-MM-DD') 
                }
                 
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'CHANGE_DATE',
                    page:NAME, 
                }) 
            }
            
        },
        DIFF(from,to,type="days"){
            try { 
                let a = moment(from)
                let b = moment(to)
                let diff = b.diff(a,type) 
                return diff
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'CHANGE_DATE',
                    page:NAME, 
                }) 
            }
            
        },

        //--------
        DIALOG_YES(action){ 
            if (action) {
                if (action.code ===NAME+"=ADD-SERVICE") {
                    if (this.input.check ) {
                        this.input.check = false 
                        this.$store.dispatch("fi_add",{
                            action:"Services",
                            path:"MBS/SETTINGS/Services/",
                            data:this.input
                        }) 
                    } 
                } 
                if (action.code ===NAME+"=REGISTER-TIMEOUT") {
                    
                }
                if (action.code ===NAME+"=GO-TO-PROFILE") {
                    this.MBS.actions.go('/profile')
                }
                if (action.code ===NAME+"=RELOAD-PAGE") {
                    this.RELOAD_PAGE()
                }
                if (action.code ===NAME+"=CANCEL-SIGNING") {
                    
                }
                
            }
        },  
        ON_DAYSHIFT_SELECTOR(action){ 
            this.dialog_audit_aggregate_sales = !this.dialog_audit_aggregate_sales
        },  
         
         
    },
    beforeDestroy(){
        try {
            this.MBS.events.$off('DIALOG_YES', this.DIALOG_YES);   
            this.MBS.events.$off('ON_DAYSHIFT_SELECTOR', this.ON_DAYSHIFT_SELECTOR);  
        } catch (error) {
            this.MBS.actions.error({
                error:error,
                from:'beforeDestroy',
                page:PAGE_NAME, 
            })
        }
    },
    watch:{ 
        us(value){ 
        },
        processes(value){ 
        },
        loading(value){ 
        }, 
        loading(value){ 
        },  
        filter_date(value){ 
            console.log(value,'v..............');
            
            this.input = {...value} || {}
        },
        fromDate(value){ 
            this.$emit('input', {
                from_date:value,
                to_date:this.toDate,
                difference:this.difference,
                outlet_code:this.OutletsFilter,
                dayshifts:this.DayShiftsFiltered,
                dayshifts_keys:this.DayShiftsKeys,
                selected_dayshifts:this.selected,
                selected_dayshifts_keys:this.SelectedDayShiftsKeys,
            })
        },
        toDate(value){ 
            this.$emit('input', {
                from_date:this.fromDate,
                to_date:value,
                difference:this.difference,
                outlet_code:this.OutletsFilter,
                dayshifts:this.DayShiftsFiltered,
                dayshifts_keys:this.DayShiftsKeys,
                selected_dayshifts:this.selected,
                selected_dayshifts_keys:this.SelectedDayShiftsKeys,
            })
        },  
    }
}
</script> 